import { getAddonsRoute, getNiusanceCallStatusRoute, postAddonRoute, postNiusanceCallFileRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { getLanguage } from "@utils/changeLanguage";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { IAddonsResponse, IMobileService, INuisanceCallStatus } from "../interface/IManageMobileServices";

export const useManageMobileServices = (callback?: () => void) => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [addonsList, setAddonsList] = useState<IMobileService[]>([]);
    const [nuisanceCallStatus, setNuisanceCallStatus] = useState<INuisanceCallStatus>();
    const [getAddonsListState, { get: getAddons }] = useFetch();
    const [getNuisanceCallStatusState, { get: getNuisanceCall }] = useFetch();
    const [postNuisanceCallDocumentStatus, { post: postNuisanceCallDocument }] = useFetch();
    const [postAddonActionStatus, { post: postAddonAction }] = useFetch();
    const lang = getLanguage();

    const formMethods = useForm<{ base64File: string }>({
        defaultValues: { base64File: "" },
    });

    const { handleSubmit, setValue } = formMethods;

    const getAddonsList = () => {
        if (selectedService) {
            getAddons<IAddonsResponse>(getAddonsRoute(selectedService.id, lang)).then((addonsListResponse) => {
                if (addonsListResponse) {
                    setAddonsList(addonsListResponse.addons);
                }
            });
        }
    };

    const getNuisanceCallStatus = () => {
        if (selectedService) {
            getNuisanceCall<INuisanceCallStatus>(getNiusanceCallStatusRoute(selectedService.id)).then(
                (nuisanceStatusResponse) => {
                    if (nuisanceStatusResponse) {
                        setNuisanceCallStatus(nuisanceStatusResponse);
                    }
                }
            );
        }
    };

    const postAddon = (addonCode: string, action: string, status: boolean, setCheckStatus: (val: boolean) => void) => {
        if (selectedService) {
            postAddonAction<boolean>(postAddonRoute(selectedService.id), {
                body: { addonCode: addonCode, action: action },
            }).then((postAddonResponse) => {
                if (postAddonResponse) {
                    setCheckStatus(status);
                }
            });
        }
    };

    const handleOnSubmit = handleSubmit((formData) => {
        if (selectedService) {
            postNuisanceCallDocument<boolean>(postNiusanceCallFileRoute(selectedService.id), {
                body: { base64File: formData.base64File },
            }).then((postNiusanceCallFileResponse) => {
                if (postNiusanceCallFileResponse) {
                    setValue("base64File", undefined);
                    getNuisanceCallStatus();
                    if (callback) callback();
                }
            });
        }
    });

    return {
        getAddonsListState,
        addonsList,
        getAddonsList,
        getNuisanceCallStatusState,
        nuisanceCallStatus,
        getNuisanceCallStatus,
        formMethods,
        postNuisanceCallDocumentStatus,
        handleOnSubmit,
        postAddon,
        postAddonActionStatus,
    };
};
